import { Component, OnInit } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
    selector: "app-shutter",
    templateUrl: "./shutter.component.html",
    styleUrls: ["./shutter.component.scss"],
})
export class ShutterComponent implements OnInit {
    display = false;

    constructor(private meta: Meta, private seoService: SeoServiceService) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.meta.addTag({
            name: "Description",
            content: "Shutter System - Safety + Durability for Every Classroom Display",
        });
    }

    iconFeatures = [
        { icon: 'security', title: 'Secure Panels', description: 'Protects your display from accidental damage' },
        { icon: 'shield', title: 'Heavy-duty metal shutter', description: 'Robust protection for your display' },
        { icon: 'linear_scale', title: 'Smooth rail movement', description: 'Easy and quiet operation' },
        { icon: 'lock', title: 'Lockable for safety', description: 'Secure your equipment when not in use' },
        { icon: 'sensor_door', title: 'Magnetized Doors', description: 'Options for Magnized door/sliding door /writing board /notice board' },
        // { icon: 'integration_instructions', title: 'Compatible with IFPs & Regular Boards', description: 'Universal compatibility for all classroom setups' },
        { icon: 'design_services', title: 'Customization', description: 'Available as per requirement: White / Green / Chalkboard finish.<br>Material options: Customizable Metal / Wooden' },
    ];

    specSections = [
        {
            label: "SPECIFICATIONS",
            headerLabel: "Details",
            columns: ['Value'],
            rows: [
                { label: "Size options", values: ["Up to 86 inches"] },
                { label: "Material", values: ["Heavy-duty Metal, Powder-coated finish"] },
                { label: "Locking system", values: ["Key Lock"] },
                { label: "Color options", values: ["White, Green"] },
                { label: "Door options", values: ["Magnized door/Sliding door"] },
                { label: "Board options", values: ["Writing Board / Notice Board"] },
            ],
        }
    ];

    useCases = [
        {
            subject: "Schools",
            description: "Protect classroom displays from accidental damage.",
            image: "assets/images/smartroom/panel.jpg",
        },
        {
            subject: "Labs",
            description: "Secure expensive equipment in laboratory environments.",
            image: "assets/images/smartroom/panel.jpg",
        },
        {
            subject: "Coaching Centers",
            description: "Durable solution for high-traffic educational centers.",
            image: "assets/images/smartroom/panel.jpg",
        },
        {
            subject: "Govt. Institutions",
            description: "Standardized protection for government educational facilities.",
            image: "assets/images/smartroom/panel.jpg",
        },
    ];
}
